/**
 * Whether a bulk profile-regeneration action may touch this opportunity.
 * Must match the backend's `flag_for_updates IS DISTINCT FROM 'Inactive'`:
 * empty and null flags are live, only the literal 'Inactive' is archived.
 */
export const isRegenerableOpportunity = (opportunity: {
  flag_for_updates: string | null | undefined
}): boolean => opportunity.flag_for_updates !== 'Inactive'
